<template>
  <div>
    <div>
      <ejs-tab ref='mmlTab' @selected='tabClicked($event)' :selecting='mmlTabSelect' height='328'>
      </ejs-tab>
    </div>
    <!-- 都是被逼的，复用一个模板tab组件会有bug !-->
    <div v-for='command in currentMo.commands' :key='command.name' :id="'mml-'+command.name" style='display: none'>
      <template v-if='showUadForm'>
        <uad-form :ref="'mml-'+command.name" :formName='command.name' @ready-to-exec='readyToExec'></uad-form>
      </template>
      <template v-else>
        <oper-form :ref="'mml-'+command.name" :formName='command.name' @ready-to-exec='readyToExec'></oper-form>
      </template>
    </div>
    <div id='codemirror' style='display: none'>
      <command-editor ref='mmlEditor' @ready-to-exec='readyToExec'></command-editor>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import OperForm from '@/components/mmlconfig/rightPanel/OperForm';
import UadForm from '@/components/mmlconfig/rightPanel/UadForm';
import CommandEditor from '@/components/mmlconfig/rightPanel/CommandEditor';
import bus from '../bus.js';

const { mapGetters, mapMutations } = createNamespacedHelpers('mmlconfig');
export default {
  name: 'command-exec',
  components: {
    OperForm,
    UadForm,
    CommandEditor
  },
  data() {
    return {
    };
  },
  created() {
    bus.$on('add2CmdEditor', mmlList => {
      mmlList.forEach(mml => {
        this.$refs.mmlEditor.addMML(mml);
      });
      // select the cmd tab
      this.$refs.mmlTab.select(this.currentMo.commands.length);
    });
  },
  computed: {
    ...mapGetters(['currentMo', 'massModifyMode']),
    showUadForm() {
      return ['etcCfgData', 'eNodeBCfgData'].includes(this.currentMo.moName);
    }
  },
  methods: {
    ...mapMutations(['changeMo', 'changeMassModMode']),
    tabClicked(e) {
      // 切換tab页时重置批量修改模式
      this.changeMassModMode(false);
      const tabItemsArr = this.$refs.mmlTab.ej2Instances.items;
      const { command } = tabItemsArr[e.selectedIndex];
      if (command && this.showUadForm) {
        this.$refs[`mml-${command.name}`][0].setInitParams(this.currentMo, command);
      } else if (command) {
        this.$refs[`mml-${command.name}`][0].refreshFormTrigger(command);
      } else {
        this.$refs.mmlEditor.refreshCmd();
      }
    },
    mmlTabSelect(e) {
      if (e.isSwiped) {
        e.cancel = true;
      }
    },
    refreshTabs(moData) {
      if (!moData) { return; }
      // store moData in vuex
      this.changeMo(moData);
      const commands = JSON.parse(JSON.stringify(this.currentMo.commands));
      if (this.showUadForm) {
        // 服了 这个上传下载表单的命令竟然和适配包里是相反的，我真是醉了
        commands.reverse();
      }
      // 当没有命令时返回，不展示Cmd
      if (commands.length <= 0) {
        return;
      }
      // add command attr in each tab
      const tabObj = commands.map(cmd => (
        { command: cmd, header: { text: this.LOCALE === 'zh'?`${cmd.zhName}`:`${cmd.enName}` }, content: `#mml-${cmd.name}` }
      ));
      tabObj.push({ header: { text: this.LOCALE === 'zh'?'命令行':'cmd' }, content: '#codemirror' });
      this.$refs.mmlTab.ej2Instances.items = tabObj;
      // 需要等待tab绑定的dom加载完再执行refresh操作，否则可能绑定失败
      this.$nextTick(() => {
        this.$refs.mmlTab.ej2Instances.refresh();
        // trigger the first tab selected event
        if (!this.showUadForm) {
          this.$refs[`mml-${commands[0].name}`][0].refreshFormTrigger(commands[0]);
        }
        if (this.showUadForm) {
          this.$refs[`mml-${commands[0].name}`][0].setInitParams(this.currentMo, commands[0]);
        }
      });
    },
    execAndExitMassMod() {
      this.$refs['mml-MOD'][0].changeToSingle();
    },
    readyToExec(cmdList, cmdMode) {
      this.$emit('do-exec', cmdList, cmdMode);
    },
  },
  beforeDestroy() {
    bus.$off('add2CmdEditor');
  },
};
</script>
<style>

</style>
